import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { LoginOutlined, LogoutOutlined, InboxOutlined, SwapOutlined } from "@ant-design/icons";

const ICONO_POR_TIPO = {
  entrada: <LoginOutlined />,
  salida: <LogoutOutlined />,
  acceso_ubicaciones: <InboxOutlined />,
  transicion_seccion: <SwapOutlined />,
};

const COLOR_POR_TIPO = {
  entrada: "#22c55e",
  salida: "#ef4444",
  acceso_ubicaciones: "#0c1f5c",
  transicion_seccion: "#c9af3a",
  interseccion: "#8a93a6",
  inicio_pasillo: "#00BFD6",
  fin_pasillo: "#00BFD6",
  punto_intermedio: "#8a93a6",
  estacion: "#800080",
  puerta: "#795548",
  rampa: "#FF6A0D",
  elevador: "#556B2F",
};

//Nodo del canvas (tipo React Flow "punto"): representa un punto navegable del mapa (entrada, salida,
//intersección, punto de acceso a ubicaciones, etc.). Ver SeccionCanvas.js para las secciones (fondo).
const NodoCanvas = ({ data, selected }) => {
  const color = COLOR_POR_TIPO[data.tipo] || "#8a93a6";
  const icono = ICONO_POR_TIPO[data.tipo];
  const esInicio = data.esNodoInicio;
  const esFin = data.esNodoFin;

  return (
    <div
      style={{
        width: 34,
        height: 34,
        borderRadius: "50%",
        background: "#fff",
        border: `3px solid ${color}`,
        boxShadow: selected ? "0 0 0 3px #00BFD655" : data.bloqueado ? "0 0 0 3px #ef444455" : "0 1px 4px rgba(0,0,0,0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color,
        fontSize: 14,
        position: "relative",
        cursor: "pointer",
      }}
      title={`${data.codigo}${data.nombre ? " - " + data.nombre : ""}`}
    >
      <Handle type="source" position={Position.Top} id="top" style={{ opacity: 0 }} />
      <Handle type="target" position={Position.Top} id="top-target" style={{ opacity: 0 }} />
      <Handle type="source" position={Position.Right} id="right" style={{ opacity: 0 }} />
      <Handle type="target" position={Position.Right} id="right-target" style={{ opacity: 0 }} />
      <Handle type="source" position={Position.Bottom} id="bottom" style={{ opacity: 0 }} />
      <Handle type="target" position={Position.Bottom} id="bottom-target" style={{ opacity: 0 }} />
      <Handle type="source" position={Position.Left} id="left" style={{ opacity: 0 }} />
      <Handle type="target" position={Position.Left} id="left-target" style={{ opacity: 0 }} />
      {icono || <span style={{ width: 6, height: 6, borderRadius: "50%", background: color }} />}
      {data.numeroParada != null && (
        <span
          style={{
            position: "absolute",
            top: -8,
            left: -8,
            background:
              data.estadoParada === "completada" ? "#22c55e" : data.estadoParada === "actual" ? "#f97316" : "#00BFD6",
            color: "#fff",
            borderRadius: "50%",
            width: data.estadoParada === "actual" ? 20 : 16,
            height: data.estadoParada === "actual" ? 20 : 16,
            fontSize: 9,
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: data.estadoParada === "actual" ? "0 0 0 4px #f9731655" : undefined,
          }}
        >
          {data.estadoParada === "completada" ? "✓" : data.numeroParada}
        </span>
      )}
      {data.totalUbicaciones > 0 && (
        <span
          style={{
            position: "absolute",
            top: -8,
            right: -8,
            background: "#c9af3a",
            color: "#fff",
            borderRadius: 8,
            fontSize: 9,
            padding: "0 4px",
            fontWeight: 700,
          }}
        >
          {data.totalUbicaciones}
        </span>
      )}
      {(esInicio || esFin) && (
        <span
          style={{
            position: "absolute",
            bottom: -16,
            fontSize: 9,
            fontWeight: 700,
            color: esInicio ? "#22c55e" : "#ef4444",
            whiteSpace: "nowrap",
          }}
        >
          {esInicio ? "INICIO" : "FIN"}
        </span>
      )}
      <span
        style={{
          position: "absolute",
          top: 38,
          fontSize: 9,
          color: "#8a93a6",
          whiteSpace: "nowrap",
          maxWidth: 80,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {data.codigo}
      </span>
    </div>
  );
};

export default NodoCanvas;
